import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=562b5cfb&scoped=true"
import script from "./comment.vue?vue&type=script&lang=ts"
export * from "./comment.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./comment.vue?vue&type=style&index=0&id=562b5cfb&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "562b5cfb",
  "65bef8e7"
  
)

export default component.exports